import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./SmartAccess.css";
import PhoneInput from "../components/PhoneInput";

const API = process.env.REACT_APP_BACKEND_URL;

export default function SMRTAccessNotify() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const siteId = searchParams.get("siteId");
  const userId = searchParams.get("userId");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [events, setEvents] = useState<string[]>([]);
  const [siteEvents, setSiteEvents] = useState<any[]>([]);
  const [siteNotifications, setSiteNotifications] = useState<any[]>([]);

  useEffect(() => {
    if (!siteId) return;
    fetch(`${API}/smrtaccess/site-state/${encodeURIComponent(siteId)}`, { credentials: "include" })
      .then(r => r.json())
      .then(data => {
        setSiteEvents(data.events || []);
        setSiteNotifications(data.notifications || []);

        if (userId) {
          const existing = (data.notifications || []).find((u: any) => u.id.toString() === userId);
          if (existing) {
            setName(existing.name || "");
            setPhone("");
            setTimeout(() => setPhone(existing.phone || ""), 0);
            setEvents(existing.events || []);
          }
        }
      })
      .catch(err => console.error("Failed to load site state:", err));
  }, [siteId, userId]);

  return (
    <div className="smrt-access-container">
      <div
        className="smrt-access-panel"
        style={{ maxWidth: "700px", margin: "0 auto" }}
      >
        <div className="panel-header">
          <h3>Access Notifications</h3>
        </div>

        <div className="panel-body">
          {!siteId ? (
            <div className="empty-state">No site selected</div>
          ) : (
            <>
              <label>User Name</label>
              <input
                className="door-input"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />

              <label>WhatsApp Number</label>
              <PhoneInput phone={phone} setPhone={setPhone} />

              <label>Event Types</label>

              <div style={{ marginTop: "6px" }}>
                {siteEvents.map((ev: any) => (
                  <div
                    key={ev.id}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={
                        ev.label === "All"
                          ? events.length === siteEvents.length
                          : events.includes(ev.id)
                      }
                      onChange={(e) => {
                        if (ev.label === "All") {
                          if (e.target.checked) {
                            setEvents(siteEvents.map((e: any) => e.id));
                          } else {
                            setEvents([]);
                          }
                          return;
                        }

                        if (e.target.checked) {
                          setEvents([
                            ...events.filter((id: string) => id !== ev.id),
                            ev.id,
                          ]);
                        } else {
                          setEvents(
                            events.filter((id: string) => id !== ev.id),
                          );
                        }
                      }}
                    />
                    <span>{ev.label}</span>
                  </div>
                ))}
              </div>

              <div className="wizard-actions">
                <button
                  className="btn-cancel"
                  onClick={() =>
                    navigate("/smrt-access", {
                      state: { siteId },
                    })
                  }
                >
                  Cancel
                </button>

                <button
                  className="btn-success"
                  onClick={async () => {
                    if (!siteId) return;

                    let updated;
                    if (userId) {
                      updated = siteNotifications.map((u: any) =>
                        u.id.toString() === userId
                          ? { ...u, name, phone, events }
                          : u,
                      );
                    } else {
                      updated = [
                        ...siteNotifications,
                        { id: Date.now(), name, phone, events },
                      ];
                    }

                    try {
                      // Fetch current state to preserve doors + events
                      const res = await fetch(`${API}/smrtaccess/site-state/${encodeURIComponent(siteId)}`, { credentials: "include" });
                      const current = await res.json();

                      await fetch(`${API}/smrtaccess/site-state/${encodeURIComponent(siteId)}`, {
                        method: "PUT", credentials: "include",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                          doors: current.doors || [],
                          events: current.events || [],
                          notifications: updated,
                        }),
                      });
                    } catch (err) {
                      console.error("Failed to save notifications:", err);
                    }

                    navigate("/smrt-access", {
                      state: { refresh: true, siteId },
                    });
                  }}
                >
                  Save
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
